// ----------------------------------------------------------------------

function path (root, sublink) {
  // if (section) return `${root}${sublink}`
  return `${root}${sublink}`
}

const ROOTS_DASHBOARD = '/dashboard'
const ROOTS_ADMIN = '/admin'
const ROOTS_APPLY = '/apply'
const ROOTS_STUDENT = '/student'

const ROOTS_EMPLOYEE = '/employee'

// for dynamic auth path
const generateAuthPath = section => {
  const ROOTS_AUTH = `/${section}/auth`
  return {
    root: ROOTS_AUTH,
    login: path(ROOTS_AUTH, '/login'),
    register: path(ROOTS_AUTH, '/register'),
    loginUnprotected: path(ROOTS_AUTH, '/login-unprotected'),
    registerUnprotected: path(ROOTS_AUTH, '/register-unprotected'),
    verify: path(ROOTS_AUTH, '/verify'),
    resetPassword: path(ROOTS_AUTH, '/reset-password'),
    newPassword: path(ROOTS_AUTH, '/new-password'),
  }
}

// ----------------------------------------------------------------------

export const PATH_APPLY_AUTH = generateAuthPath('apply')
export const PATH_STUDENT_AUTH = generateAuthPath('student')
export const PATH_ADMIN_AUTH = generateAuthPath('admin')

export const PATH_PATIENT_AUTH = generateAuthPath('patient')
export const PATH_EMP_AUTH = generateAuthPath('employee')
// export const PATH_INV_AUTH = generateAuthPath('inventory')
// export const PATH_MANAGER_AUTH = generateAuthPath('manager')
// export const PATH_MD_AUTH = generateAuthPath('doctor')
// export const PATH_THERAPIST_AUTH = generateAuthPath('therapist')

// eslint-disable-next-line consistent-return
export const getAuthPath = section => {
  if (section === 'apply') return PATH_APPLY_AUTH
  if (section === 'student') return PATH_STUDENT_AUTH
  if (section === 'admin') return PATH_ADMIN_AUTH

  // if (section === 'manager') return PATH_MANAGER_AUTH
  // if (section === 'inventory') return PATH_INV_AUTH
  // if (section === 'doctor') return PATH_MD_AUTH
  // if (section === 'therapist') return PATH_THERAPIST_AUTH
  if (section === 'employee') return PATH_EMP_AUTH
  if (section === 'patient') return PATH_PATIENT_AUTH
}

export const PATH_PAGE = {
  comingSoon: '/coming-soon',
  maintenance: '/maintenance',
  pricing: '/pricing',
  payment: '/payment',
  about: '/about-us',
  contact: '/contact-us',
  faqs: '/faqs',
  page403: '/403',
  page404: '/404',
  page500: '/500',
  components: '/components',
}

export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,
  general: {
    app: path(ROOTS_DASHBOARD, '/app'),
    ecommerce: path(ROOTS_DASHBOARD, '/ecommerce'),
    analytics: path(ROOTS_DASHBOARD, '/analytics'),
    banking: path(ROOTS_DASHBOARD, '/banking'),
    booking: path(ROOTS_DASHBOARD, '/booking'),
  },
  eCommerce: {
    root: path(ROOTS_DASHBOARD, '/e-commerce'),
    shop: path(ROOTS_DASHBOARD, '/e-commerce/shop'),
    list: path(ROOTS_DASHBOARD, '/e-commerce/list'),
    checkout: path(ROOTS_DASHBOARD, '/e-commerce/checkout'),
    new: path(ROOTS_DASHBOARD, '/e-commerce/product/new'),
    view: name => path(ROOTS_DASHBOARD, `/e-commerce/product/${name}`),
    edit: name => path(ROOTS_DASHBOARD, `/e-commerce/product/${name}/edit`),
    demoEdit: path(ROOTS_DASHBOARD, '/e-commerce/product/nike-blazer-low-77-vintage/edit'),
    demoView: path(ROOTS_DASHBOARD, '/e-commerce/product/nike-air-force-1-ndestrukt'),
  },
  blog: {
    root: path(ROOTS_DASHBOARD, '/blog'),
    posts: path(ROOTS_DASHBOARD, '/blog/posts'),
    new: path(ROOTS_DASHBOARD, '/blog/new'),
    view: title => path(ROOTS_DASHBOARD, `/blog/post/${title}`),
    demoView: path(ROOTS_DASHBOARD, '/blog/post/apply-these-7-secret-techniques-to-improve-event'),
  },
  permissionDenied: path(ROOTS_DASHBOARD, '/permission-denied'),
}

export const PATH_ADMIN = {
  root: ROOTS_ADMIN,
  colleges: {
    root: path(ROOTS_ADMIN, '/colleges'),
    college: code => path(ROOTS_ADMIN, `/colleges/${code}`),
    collegeTab: (code, tab) => path(ROOTS_ADMIN, `/colleges/${code}/${tab}`),
    examCreate: code => path(ROOTS_ADMIN, `/colleges/${code}/exams/create`),
    examEdit: (code, id) => path(ROOTS_ADMIN, `/colleges/${code}/exams/${id}/edit`),
    lessonCreate: code => path(ROOTS_ADMIN, `/colleges/${code}/lessons/create`),
    lessonEdit: (code, id) => path(ROOTS_ADMIN, `/colleges/${code}/lessons/${id}/edit`),
    sectionCreate: code => path(ROOTS_ADMIN, `/colleges/${code}/sections/create`),
    sectionStudentUpload: code => path(ROOTS_ADMIN, `/colleges/${code}/sections/upload/student`),
    sectionEdit: (code, id) => path(ROOTS_ADMIN, `/colleges/${code}/sections/${id}/edit`),
    courseTemplate: (code, id) => path(ROOTS_ADMIN, `/colleges/${code}/courses/${id}/template`),
    courseTemplateCreate: code => path(ROOTS_ADMIN, `/colleges/${code}/course%20templates/create`),
    courseTemplateEdit: (code, id) => path(ROOTS_ADMIN, `/colleges/${code}/course%20templates/${id}/edit`),

    //
    // registrations: code => path(ROOTS_ADMIN, `/colleges/${code}/registrations`),

    registrationCreate: code => path(ROOTS_ADMIN, `/colleges/${code}/registrations/create`),
    registrationView: (code, id) => path(ROOTS_ADMIN, `/colleges/${code}/registrations/${id}`),
    registrationEdit: (code, id) => path(ROOTS_ADMIN, `/colleges/${code}/registrations/${id}/edit`),

    students: code => path(ROOTS_ADMIN, `/colleges/${code}/students`),
    studentRecords: (code, id) => path(ROOTS_ADMIN, `/colleges/${code}/students/${id}/records`),
    studentRegistrations: (code, id) => path(ROOTS_ADMIN, `/colleges/${code}/students/${id}/registrations`),
    studentGrades: (code, id) => path(ROOTS_ADMIN, `/colleges/${code}/students/${id}/grades`),
    studentEvaluation: (code, id) => path(ROOTS_ADMIN, `/colleges/${code}/students/${id}/evaluation`),

    studentRecord: (code, id) => path(ROOTS_ADMIN, `/colleges/${code}/students/records/${id}`),

  },
  admissions: {
    root: path(ROOTS_ADMIN, '/admissions'),
    //
    approvals: path(ROOTS_ADMIN, '/admissions/approvals'),
    viewApprovalRequests: id => path(ROOTS_ADMIN, `/admissions/approvals/${id}`),
    //
    applicants: path(ROOTS_ADMIN, '/admissions/applicants'),
    applicantEdit: id => path(ROOTS_ADMIN, `/admissions/applicants/${id}/edit`),
    //
    applications: path(ROOTS_ADMIN, '/admissions/applications'),
    applicantViewApplication: id => path(ROOTS_ADMIN, `/admissions/applicants/${id}/application`),
    //
    periods: path(ROOTS_ADMIN, '/admissions/periods'),
    periodEdit: id => path(ROOTS_ADMIN, `/admissions/periods/${id}/edit`),
    //
    admissionReports: path(ROOTS_ADMIN, '/admissions/reports'),
    //
    admissionWorkflows: path(ROOTS_ADMIN, '/admissions/workflows'),
    admissionWorkflowsCreate: path(ROOTS_ADMIN, '/admissions/workflows/create'),
    admissionWorkflowsEdit: id => path(ROOTS_ADMIN, `/admissions/workflows/${id}/edit`),
    //
    schedules: path(ROOTS_ADMIN, '/admissions/schedules'),
    schedulesCreate: path(ROOTS_ADMIN, '/admissions/schedules/create'),
    schedulesEdit: id => path(ROOTS_ADMIN, `/admissions/schedules/${id}/edit`),
  },
  registrar: {
    root: path(ROOTS_ADMIN, '/registrar'),
    //
    courses: path(ROOTS_ADMIN, '/registrar/courses'),
    courseCreate: path(ROOTS_ADMIN, '/registrar/courses/create'),
    courseEdit: id => path(ROOTS_ADMIN, `/registrar/courses/${id}/edit`),
    //
    programs: path(ROOTS_ADMIN, '/registrar/programs'),
    programCreate: path(ROOTS_ADMIN, '/registrar/programs/create'),
    programEdit: id => path(ROOTS_ADMIN, `/registrar/programs/${id}/edit`),
    //
    curriculums: path(ROOTS_ADMIN, '/registrar/curriculums'),
    curriculumCreate: path(ROOTS_ADMIN, '/registrar/curriculums/create'),
    curriculumEdit: id => path(ROOTS_ADMIN, `/registrar/curriculums/${id}/edit`),
    //
    periods: path(ROOTS_ADMIN, '/registrar/periods'),
    periodTab: (tab) => path(ROOTS_ADMIN, `/registrar/periods/${tab}`),
    periodCreate: path(ROOTS_ADMIN, '/registrar/periods/create'),
    periodEdit: id => path(ROOTS_ADMIN, `/registrar/periods/${id}/edit`),

    otherSchedCreate: path(ROOTS_ADMIN, '/registrar/periods/schedule-templates/create'),
    otherSchedEdit: id => path(ROOTS_ADMIN, `/registrar/periods/schedule-templates/${id}/edit`),
    //
    students: path(ROOTS_ADMIN, '/registrar/students'),
    studentCreate: path(ROOTS_ADMIN, '/registrar/students/create'),
    studentView: id => path(ROOTS_ADMIN, `/registrar/students/${id}`),
    studentEdit: id => path(ROOTS_ADMIN, `/registrar/students/${id}/edit`),
    studentTab: (id, tab) => path(ROOTS_ADMIN, `/registrar/students/${id}/${tab}`),
    //
    reports: path(ROOTS_ADMIN, '/registrar/reports'),
  },
  accounting: {
    root: path(ROOTS_ADMIN, '/accounting'),
    reports: path(ROOTS_ADMIN, '/accounting/reports'),
    findProfile: path(ROOTS_ADMIN, '/accounting/find-profile'),
    findProfileView: id => path(ROOTS_ADMIN, `/accounting/find-profile/${id}/view`),
    profileCreateBilling: id => path(ROOTS_ADMIN, `/accounting/find-profile/${id}/create-billing`),
    //
    accounts: path(ROOTS_ADMIN, '/accounting/accounts'),
    accountCreate: path(ROOTS_ADMIN, '/accounting/accounts/create'),
    accountEdit: id => path(ROOTS_ADMIN, `/accounting/accounts/${id}/edit`),
    //
    specialFees: path(ROOTS_ADMIN, '/accounting/special-fees'),
    specialFeeEdit: id => path(ROOTS_ADMIN, `/accounting/special-fees/${id}/edit`),
    //
    // tableOfFees: path(ROOTS_ADMIN, '/accounting/table-of-fees'),
    tableOfFeesTab: (tab) => path(ROOTS_ADMIN, `/accounting/table-of-fees/${tab}`),
    tableOfFeeCreate: path(ROOTS_ADMIN, '/accounting/table-of-fees/create'),
    feeSchedCreate: path(ROOTS_ADMIN, '/accounting/table-of-fees/schedules/create'),
    feeSchedEdit: id => path(ROOTS_ADMIN, `/accounting/table-of-fees/schedules/${id}/edit`),
    tableOfFeeEdit: id => path(ROOTS_ADMIN, `/accounting/table-of-fees/${id}/edit`),
    feePrograms: id => path(ROOTS_ADMIN, `/accounting/table-of-fees/${id}/programs`),
    feeOptions: id => path(ROOTS_ADMIN, `/accounting/table-of-fees/${id}/options`),
    //
    scholarships: path(ROOTS_ADMIN, '/accounting/scholarships'),
    scholarshipCreate: path(ROOTS_ADMIN, '/accounting/scholarships/create'),
    scholarshipEdit: id => path(ROOTS_ADMIN, `/accounting/scholarships/${id}/edit`),
    //
    billings: path(ROOTS_ADMIN, '/accounting/billings'),
    billingCreate: (profileId) => path(ROOTS_ADMIN, `/accounting/${profileId}/billings/create`),
    billingEdit: (profileId, id) => path(ROOTS_ADMIN, `/accounting/${profileId}/billings/${id}/edit`),
    //
    payments: path(ROOTS_ADMIN, '/accounting/payments'),
    paymentCreate: profileId => path(ROOTS_ADMIN, `/accounting/${profileId}/payments/create`),
    paymentEdit: (profileId, id) => path(ROOTS_ADMIN, `/accounting/${profileId}/payments/${id}/edit`),
    //
    memoCreate: profileId => path(ROOTS_ADMIN, `/accounting/${profileId}/memos/create`),
    memoEdit: (profileId, id) => path(ROOTS_ADMIN, `/accounting/${profileId}/memos/${id}/edit`),
  },
  cashiering: {
    root: path(ROOTS_ADMIN, '/cashiering'),
    //
    findProfile: path(ROOTS_ADMIN, '/cashiering/find-profile'),
    findProfileView: id => path(ROOTS_ADMIN, `/cashiering/find-profile/${id}/view`),
    profileCreatePayment: id => path(ROOTS_ADMIN, `/cashiering/find-profile/${id}/create-payment`),
    //
    billings: path(ROOTS_ADMIN, '/cashiering/billings'),
    billingCreate: (profileId) => path(ROOTS_ADMIN, `/cashiering/${profileId}/billings/create`),
    billingEdit: (profileId, id) => path(ROOTS_ADMIN, `/cashiering/${profileId}/billings/${id}/edit`),
    //
    payments: path(ROOTS_ADMIN, '/cashiering/payments'),

    paymentCreate: (profileId) => path(ROOTS_ADMIN, `/cashiering/${profileId}/payments/create`),
    paymentEdit: (profileId, id) => path(ROOTS_ADMIN, `/cashiering/${profileId}/payments/${id}/edit`),

    //
    orIssuances: path(ROOTS_ADMIN, '/cashiering/or-issuance'),
    orIssuanceCreate: path(ROOTS_ADMIN, '/cashiering/or-issuance/create'),
    orIssuanceEdit: id => path(ROOTS_ADMIN, `/cashiering/or-issuance/${id}/edit`),
  },
  administrator: {
    root: path(ROOTS_ADMIN, '/administrator'),
    //
    departments: path(ROOTS_ADMIN, '/administrator/departments'),
    departmentCreate: path(ROOTS_ADMIN, '/administrator/departments/create'),
    departmentEdit: id => path(ROOTS_ADMIN, `/administrator/departments/${id}/edit`),
    //
    announcements: path(ROOTS_ADMIN, '/administrator/announcements'),
    announcementCreate: path(ROOTS_ADMIN, '/administrator/announcements/create'),
    announcementEdit: id => path(ROOTS_ADMIN, `/administrator/announcements/${id}/edit`),
    //
    employees: path(ROOTS_ADMIN, '/administrator/employees'),
    employeeCreate: path(ROOTS_ADMIN, '/administrator/employees/create'),
    employeeEdit: id => path(ROOTS_ADMIN, `/administrator/employees/${id}/edit`),
    //
    settings: path(ROOTS_ADMIN, '/administrator/settings'),
    settingEdit: id => path(ROOTS_ADMIN, `/administrator/settings/${id}/edit`),
  },
  faculty: {
    root: path(ROOTS_ADMIN, '/faculty'),
    classes: path(ROOTS_ADMIN, '/faculty/classes'),
    viewClasses: (id, tab) => path(ROOTS_ADMIN, `/faculty/classes/${id}/${tab}`),
    exams: path(ROOTS_ADMIN, '/faculty/exams'),
    examCreate: path(ROOTS_ADMIN, `/faculty/exams/create`),
    examEdit: id => path(ROOTS_ADMIN, `/faculty/exams/${id}`),
  },
  counselor: {
    root: path(ROOTS_ADMIN, '/counselor'),
    students: path(ROOTS_ADMIN, '/counselor/students'),
    viewStudents: id => path(ROOTS_ADMIN, `/counselor/students/${id}`),
    viewStudentTab: (id, tab) => path(ROOTS_ADMIN, `/counselor/students/${id}/${tab}`),
  },
}

export const PATH_APPLY = {
  root: ROOTS_APPLY,
  home: path(ROOTS_APPLY, `/home`),
  profile: path(ROOTS_APPLY, `/profile`),
  billings: path(ROOTS_APPLY, `/billings`),
  applications: path(ROOTS_APPLY, `/applications`),
}

export const PATH_STUDENT = {
  root: ROOTS_STUDENT,
  home: path(ROOTS_STUDENT, `/home`),
  settings: path(ROOTS_STUDENT, `/settings`),
  payments: path(ROOTS_STUDENT, `/payments`),
  billings: path(ROOTS_STUDENT, `/billings`),
  registration: path(ROOTS_STUDENT, `/registration`),
  tickets: path(ROOTS_STUDENT, `/tickets`),
  courses: path(ROOTS_STUDENT, `/courses`), 
  courseView: courseId => path(ROOTS_STUDENT, `/courses/${courseId}`),
  records: path(ROOTS_STUDENT, `/records`),
  curriculum: path(ROOTS_STUDENT, `/curriculum`),
  grades: path(ROOTS_STUDENT, `/grades`),
  exams: path(ROOTS_STUDENT, `/exams`),
  examTake: id => path(ROOTS_STUDENT, `/exams/${id}`),
}

export const PATH_EMPLOYEE = {
  root: ROOTS_EMPLOYEE,
  employeeHome: path(ROOTS_EMPLOYEE, `/home`),
  managerDash: path(ROOTS_EMPLOYEE, `/manager-dash`),

  patients: path(ROOTS_EMPLOYEE, `/patients`),
  patientList: path(ROOTS_EMPLOYEE, `/patients/list`),
  patientCreate: path(ROOTS_EMPLOYEE, `/patients/create`),
  patient: id => path(ROOTS_EMPLOYEE, `/patients/${id}`),
  patientTab: (id, tab) => path(ROOTS_EMPLOYEE, `/patients/${id}/${tab}`),
  patientEdit: id => path(ROOTS_EMPLOYEE, `/patients/${id}/edit`),
  patientView: id => path(ROOTS_EMPLOYEE, `/patients/${id}/view`),

  doctors: path(ROOTS_EMPLOYEE, `/doctors`),
  doctorList: path(ROOTS_EMPLOYEE, `/doctors/list`),
  doctorCreate: path(ROOTS_EMPLOYEE, `/doctors/create`),
  doctor: id => path(ROOTS_EMPLOYEE, `/doctors/${id}`),
  doctorTab: (id, tab) => path(ROOTS_EMPLOYEE, `/doctors/${id}/${tab}`),
  doctorEdit: id => path(ROOTS_EMPLOYEE, `/doctors/${id}/edit`),

  therapists: path(ROOTS_EMPLOYEE, `/therapists`),
  therapistList: path(ROOTS_EMPLOYEE, `/therapists/list`),
  therapistCreate: path(ROOTS_EMPLOYEE, `/therapists/create`),
  therapist: id => path(ROOTS_EMPLOYEE, `/therapists/${id}`),
  therapistTab: (id, tab) => path(ROOTS_EMPLOYEE, `/therapists/${id}/${tab}`),
  therapistEdit: id => path(ROOTS_EMPLOYEE, `/therapists/${id}/edit`),

  employees: path(ROOTS_EMPLOYEE, `/employees`),
  employeeList: path(ROOTS_EMPLOYEE, `/employees/list`),
  employeeCreate: path(ROOTS_EMPLOYEE, `/employees/create`),
  employee: id => path(ROOTS_EMPLOYEE, `/employees/${id}`),
  employeeTab: (id, tab) => path(ROOTS_EMPLOYEE, `/employees/${id}/${tab}`),
  employeeEdit: id => path(ROOTS_EMPLOYEE, `/employees/${id}/edit`),

  salaryTemplates: path(ROOTS_EMPLOYEE, `/employees/salary-templates/list`),
  salaryTemplateEdit: id => path(ROOTS_EMPLOYEE, `/employees/salary-templates/${id}/edit`),
  salaryTemplateCreate: path(ROOTS_EMPLOYEE, `/employees/salary-templates/create`),

  salaryStructureEmployee: id => path(ROOTS_EMPLOYEE, `/employees/${id}/salary-structure`),

  salaryPayrollEntries: path(ROOTS_EMPLOYEE, `/employees/payroll-entries/list`),
  salaryPayrollEntryCreate: path(ROOTS_EMPLOYEE, `/employees/payroll-entries/create`),
  salaryPayrollEntryEdit: id => path(ROOTS_EMPLOYEE, `/employees/payroll-entries/${id}/edit`),

  attendance: path(ROOTS_EMPLOYEE, `/attendance`),
  attendanceRecords: path(ROOTS_EMPLOYEE, `/attendance/records`),
  attendanceRecordsStaff: (staffType, employeeId) => path(ROOTS_EMPLOYEE, `/attendance/records/${staffType}/${employeeId}`),
  attendanceEditRequests: path(ROOTS_EMPLOYEE, `/attendance/edit-requests`),
  
  myAttendance: path(ROOTS_EMPLOYEE, `/my-attendance`),
  myAttendanceRecords: path(ROOTS_EMPLOYEE, `/my-attendance/records`),
  myAttendanceEditRequests: path(ROOTS_EMPLOYEE, `/my-attendance/edit-requests`),
  myAttendanceLeaveRequests: path(ROOTS_EMPLOYEE, `/my-attendance/leave-request`),
  myOvertimeRequests: path(ROOTS_EMPLOYEE, `/my-attendance/overtime-request`),
  // myAttendanceChangeRequests: path(ROOTS_EMPLOYEE, `/my-attendance/change-request`),

  myCommissions: path(ROOTS_EMPLOYEE, `/my-commissions`),

  requestsDTRChange: path(ROOTS_EMPLOYEE, `/attendance/change-request`),
  requestsLeave: path(ROOTS_EMPLOYEE, `/attendance/leave-request`),
  requestsLeaveCreate: path(ROOTS_EMPLOYEE, `/attendance/leave-request/create`),
  requestsLeaveEdit: (id) => path(ROOTS_EMPLOYEE, `/attendance/leave-request/${id}/edit`),
  requestsOvertime: path(ROOTS_EMPLOYEE, `/attendance/overtime-request`),

  cashFunds: path(ROOTS_EMPLOYEE, `/cash-funds`),
  cashRequests: path(ROOTS_EMPLOYEE, `/cash-requests`),
  myCashRequests: path(ROOTS_EMPLOYEE, `/my-cash-requests`),

  transactions: path(ROOTS_EMPLOYEE, `/transactions`),
  transactionList: path(ROOTS_EMPLOYEE, `/transactions/list`),
  transactionCreate: path(ROOTS_EMPLOYEE, `/transactions/create`),
  transactionsOnline: path(ROOTS_EMPLOYEE, `/transactions/online`),
  transactionCommissions: path(ROOTS_EMPLOYEE, `/transactions/commissions`),

  products: path(ROOTS_EMPLOYEE, `/products`),
  productList: path(ROOTS_EMPLOYEE, `/products/list`),
  productCreate: path(ROOTS_EMPLOYEE, `/products/create`),
  product: id => path(ROOTS_EMPLOYEE, `/products/${id}`),
  productTab: (id, tab) => path(ROOTS_EMPLOYEE, `/products/${id}/${tab}`),
  productView: id => path(ROOTS_EMPLOYEE, `/products/${id}/view`),
  productEdit: id => path(ROOTS_EMPLOYEE, `/products/${id}/edit`),

  inventoryDash: path(ROOTS_EMPLOYEE, `/inventory`),

  inventoryList: path(ROOTS_EMPLOYEE, `/inventory/list`),
  inventoryCreate: path(ROOTS_EMPLOYEE, `/inventory/create`),
  inventoryView: (id, branch) => path(ROOTS_EMPLOYEE, `/inventory/${id}${branch ? `?branch=${branch}` : ''}`),

  shop: path(ROOTS_EMPLOYEE, `/shop`),

  appointments: path(ROOTS_EMPLOYEE, `/appointments`),
  appointmentList: path(ROOTS_EMPLOYEE, `/appointments/list`),
  appointmentCreate: path(ROOTS_EMPLOYEE, `/appointments/create`),
  bookingBlocks: path(ROOTS_EMPLOYEE, `/booking-blocks`),

  medicalRecords: path(ROOTS_EMPLOYEE, `/patients/medical-records`),
  medicalRecordList: path(ROOTS_EMPLOYEE, `/patients/medical-records/`),
  medicalRecordCreate: id => path(ROOTS_EMPLOYEE, `/patients/medical-records/${id}/create`),
  medicalRecord: id => path(ROOTS_EMPLOYEE, `/patients/medical-records/${id}/view`),
  medicalRecordEdit: id => path(ROOTS_EMPLOYEE, `/patients/medical-records/${id}/edit`),
  patientMedicalRecordList: id => path(ROOTS_EMPLOYEE, `/patients/medical-records/${id}/list`),
  medicalRecordById: (patientId, medRecId) => path(ROOTS_EMPLOYEE, `/patients/medical-records/${patientId}/edit/${medRecId}`),

  reports: path(ROOTS_EMPLOYEE, `/reports`),
  reportSales: path(ROOTS_EMPLOYEE, `/reports/sales`),
  reportCommissions: path(ROOTS_EMPLOYEE, `/reports/commissions`),
  reportForm1: path(ROOTS_EMPLOYEE, `/reports/form-1`),
  reportForm2: path(ROOTS_EMPLOYEE, `/reports/form-2`),
  reportForm3: path(ROOTS_EMPLOYEE, `/reports/form-3`),

  reportEvaluations: path(ROOTS_EMPLOYEE, `/reports/evaluations`),

  settings: path(ROOTS_EMPLOYEE, `/settings`),
  settingEdit: id => path(ROOTS_EMPLOYEE, `/settings/${id}/edit`),
}

export const PATH_PATIENT = {
  root: '/patient',
  home: '/patient/home',
  shop: '/patient/shop',
  cart: '/patient/shop/cart',
  myOrders: '/patient/my-orders',
  productView: id => `/patient/products/${id}/view`,
  myAppointments: '/patient/my-appointments',
  appointments: '/patient/appointments',
  appointment: id => `/patient/appointments/${id}`,
}

export const getHomePath = (pathname) => {
  let path = '/'
  if (pathname.includes('apply')) path = PATH_APPLY.root
  else if (pathname.includes('student')) path = PATH_STUDENT.root
  else if (pathname.includes('admin')) path = PATH_ADMIN.root

    // else if (pathname.includes('manager')) path = PATH_EMPLOYEE.root
    // else if (pathname.includes('inventory')) path = PATH_INVENTORY.root
    // else if (pathname.includes('doctor')) path = PATH_DOCTOR.root
    // else if (pathname.includes('therapist')) path = PATH_THERAPIST.root
  else if (pathname.includes('employee')) path = PATH_EMPLOYEE.root
  else if (pathname.includes('patient')) path = PATH_PATIENT.root

  return path
}

export const PATH_DOCS = 'https://docs-minimals.vercel.app/introduction'
